import { gql } from '@apollo/client';

export const PEOPLE_PROFILE_INSTITUTION = gql`
  fragment peopleProfileInstitution on PeopleProfileInstitution {
    id
    designation
    startDate
    endDate
    postLevel
    primary
    year
    registrationDate
    dateExited
    trackingId
    linkedToAnInstitution
    linkedToAnOrganisation
    reasonForTermination {
      id
      name
    }
    type {
      id
      name
    }
    position {
      id
      name
    }
    positionOther
    progressionStatus {
      id
      name
    }
    ageCohort
    phases {
      id
      name
    }
    grades {
      id
      value
      name
    }
    subjects {
      id
      name
      subjectGradeReference
    }
    reasonForTermination {
      id
      name
    }
    role {
      id
      name
    }
    institution {
      id
      name
      emisNumber
      district {
        id
        name
      }
      type {
        id
        name
      }
      province {
        id
        name
      }
      localMunicipality {
        id
        localMunicipalityShorthand
        localMunicipality
      }
      communityType {
        id
        name
      }
      districtMunicipality {
        id
        name
      }
    }
  }
`;
